import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import api from "../../services/api";
import apagar from "../../assets/icons8-apagar-para-sempre-48 (2).png";
import "./styles.scss";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { Tooltip } from "antd";
import { MdNotificationsOff } from "react-icons/md";

import { formatarMensagem, formatarTipo } from "./Formatacao_alerta";
import Preloader from "../PreloaderGrids/Preloader";
import logo from "../../assets/logo.png"


function Alertas() {
  const [marcadores, setMarcadores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [ativo, setAtivo] = useState(true);
  const [timerAtivo, setTimerAtivo] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isAdminState, setIsAdminState] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);




  const navigate = useNavigate();
  const limits = async (event) => {
    const value = Number(event.target.value);

    if (!value || value === Number(itemsPerPage)) return;

    setItemsPerPage(value);
    setLimit(value);
    setCurrentPage(1);


    Swal.fire({
      title: "",
      html: `
    <div class="sync-page-loader">

      <div class="sync-page-top">
        <div class="sync-page-live">
          <span></span>
          LIVE
        </div>
      </div>

      <div class="sync-page-icon">
        <div class="sync-page-icon-glow"></div>

        <div class="sync-page-orbit sync-page-orbit-one"></div>
        <div class="sync-page-orbit sync-page-orbit-two"></div>

        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect
            x="3.5" y="4.5" width="17" height="15"
            rx="2.5"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M8 9H16M8 12H13"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M15.5 15.5L17 17L20.5 13.5"
            stroke="#52dafa"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div class="sync-page-heading">
        <span class="sync-page-eyebrow">RECONFIGURAÇÃO DE INTERFACE</span>

        <h2>Atualizando visualização<span>.</span></h2>

        <p>
          Preparando seus alertas para uma<br/>
          experiência mais organizada.
        </p>
      </div>

      <div class="sync-page-count-card">
        <div class="sync-page-count-info">
          <span>REGISTROS POR PÁGINA</span>
          <small>Nova configuração</small>
        </div>

        <div class="sync-page-count-value">
          ${value}<span> itens</span>
        </div>
      </div>

      <div class="sync-page-progress-header">
        <span>Aplicando configurações</span>
        <span class="sync-page-progress-status">EM ANDAMENTO</span>
      </div>

      <div class="sync-page-track">
        <div class="sync-page-progress"></div>
      </div>

      <div class="sync-page-footer">
        <span>
          <i></i>
          SINCRONIZANDO DADOS
        </span>
        <span>INOVA RASTREAMENTO</span>
      </div>

    </div>
  `,

      background: "transparent",
      color: "#edf7fb",
      width: 440,
      padding: "0",
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false,

      customClass: {
        popup: "swal-paginacao-tech",
        htmlContainer: "swal-paginacao-container",
      },
    });

    try {
      await fetchData(1, value);
    } finally {
      Swal.close();
    }
  };

  const buscarTodosAlertas = async () => {
    const { data } = await api.get("/alertas", {
      params: {
        page: 1,
        limit: "todos",
        searchTerm,
      },
      headers: {
        typo: localStorage.getItem("id"),
      },

    });

    return data.notificacoes_alertas || [];

  };



  //SELECIONAR TODOS
  const handleSelectAll = async () => {
    if (selectedItems.length > 0) {
      setSelectedItems([]);
      return;
    }


    Swal.fire({
      html: `
    <div class="sync-loader">

      <div class="sync-loader-icon">
        <div class="sync-loader-ring"></div>
        <div class="sync-loader-ring sync-loader-ring-inner"></div>

      </div>

      <div class="sync-loader-title">
        Sincronizando consulta
      </div>

      <div class="sync-loader-subtitle">
        Selecionando alertas e atualizando registros
      </div>

      <div class="sync-loader-line">
        <span></span>
      </div>

      <div class="sync-loader-status">
        <span class="sync-loader-status-dot"></span>
        PROCESSANDO DADOS
      </div>

    </div>
  `,

      background: "transparent",
      color: "#edf5fc",
      width: 380,
      padding: "0",
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false,

      customClass: {
        popup: "sync-loader-popup",
        htmlContainer: "sync-loader-container",
      },
    });


    try {
      const todosAlertas = await buscarTodosAlertas();

      const todos = todosAlertas.map((m) => ({
        id_ocorrencia: m.id_ocorrencia,
        placa: m.placa,
        endereco: m.endereco,
        posicao_em: m.posicao_em ?? m.data_posicao,
        tipo: m.tipo,
        mensagem: m.mensagem,
        mensagem_formatada: m.mensagem_formatada,
        finalizado_por: m.finalizado_por,
      }));

      setSelectedItems(todos);
    } catch (error) {
      console.error("Erro ao selecionar todos os alertas:", error);

      Swal.fire({
        icon: "error",
        title: "Erro ao selecionar",
        text: "Não foi possível selecionar todos os alertas.",
      });

      return;
    } finally {
      Swal.close();
    }
  };






  async function fetchData(
    pagina = currentPage,
    limite = Number(itemsPerPage) || 30
  ) {
    if (!ativo) return;

    try {
      const { data } = await api.get("/alertas", {
        params: {
          page: pagina,
          limit: limite,
          searchTerm,
        },
        headers: {
          typo: localStorage.getItem("id"),
        },
      });

      if (!ativo) return;

      const notificacoes = data.notificacoes_alertas || [];
      const total = Number(data.total || 0);

      setMarcadores(notificacoes);
      setTotalItems(total);
      setTotalPages(
        Math.max(1, Math.ceil(total / (Number(data.limit) || limite)))
      );

      window.dispatchEvent(new Event("atualizar_alertas"));
    } catch (error) {
      console.error("Erro ao buscar alertas:", error);
    } finally {
      if (ativo) {
        setLoading(false);
      }
    }
  }






  useEffect(() => {
    fetchData();

    let interval = null;

    if (timerAtivo) {
      interval = setInterval(() => {
        fetchData();
      }, 60000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };

  }, [currentPage, limit, searchTerm, timerAtivo]);



  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Resetar para a primeira página ao fazer uma nova busca
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1); // Resetar para a primeira página ao alterar o limite
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setCurrentPage(1);
  };
  /* =======================================
FINALIZAR ALERTA
======================================= */


  const finalizarAlerta = async (marcador, e) => {
    const escapeHtml = (value) =>
      String(value ?? "").replace(/[&<>"']/g, (char) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[char]);

    const { value: obs, isConfirmed } = await Swal.fire({
      title: "Finalizar alerta",
      background: "#0b1923",
      color: "#edf7fb",
      width: 420,
      padding: "26px",
      html: `
      <div style="text-align:left;margin-top:6px">
        <p style="
          color:#8da8b7;
          font-size:13px;
          line-height:1.6;
          margin:0 0 22px;
        ">
          Confirme o encerramento desta notificação.
        </p>

        <div style="margin-bottom:20px">
          <div style="
            display:flex;
            align-items:center;
            justify-content:space-between;
            margin-bottom:12px;
          ">
            <span style="
              font-size:10px;
              letter-spacing:1.3px;
              color:#7895a5;
              font-weight:600;
            ">
              VEÍCULO
            </span>

            <span style="
              font-size:11px;
              color:#86b6c9;
            ">
              Notificação ativa
            </span>
          </div>

          <div style="
            font-size:18px;
            font-weight:650;
            color:#f0f8fc;
            letter-spacing:.5px;
          ">
            ${escapeHtml(marcador.placa)}
          </div>

          <div style="
            height:1px;
            background:rgba(148,190,210,.13);
            margin:17px 0;
          "></div>

          <div style="
            font-size:10px;
            letter-spacing:1.3px;
            color:#7895a5;
            font-weight:600;
            margin-bottom:8px;
          ">
            MOTIVO DO ALERTA
          </div>

          <div style="
            font-size:13px;
            line-height:1.7;
            color:#c3d4dd;
            overflow-wrap:anywhere;
          ">
            ${escapeHtml(
        formatarMensagem(marcador.mensagem, marcador.tipo)
      )}
          </div>
        </div>

        <label for="obs-finalizar" style="
          display:block;
          font-size:11px;
          font-weight:600;
          letter-spacing:.3px;
          color:#a8c0cc;
          margin-bottom:8px;
          text-align:left;
        ">
          OBSERVAÇÃO <span style="color:#63c8ee">*</span>
        </label>
      </div>
    `,

      input: "textarea",
      inputPlaceholder: "Descreva o motivo da finalização...",
      inputAttributes: {
        id: "obs-finalizar",
        "aria-label": "Observação obrigatória",
        maxlength: 2000,
      },

      customClass: {
        popup: "swal-finalizar-premium",
        title: "swal-finalizar-titulo",
        htmlContainer: "swal-finalizar-conteudo",
        input: "swal-finalizar-input",
        confirmButton: "swal-finalizar-confirmar",
        cancelButton: "swal-finalizar-cancelar",
      },

      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "A observação é obrigatória.";
        }
      },

      showCancelButton: true,
      confirmButtonText: "Finalizar alerta",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      focusCancel: true,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    if (!isConfirmed) {
      if (e?.target) e.target.checked = false;
      return;
    }

    try {
      Swal.fire({
        title: "Finalizando alerta",
        html: `
        <div style="
          color:#8da8b7;
          font-size:12px;
          margin-top:8px;
        ">
          Processando solicitação...
        </div>
      `,
        background: "#0b1923",
        color: "#edf7fb",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: "swal-finalizar-premium",
        },
        didOpen: () => Swal.showLoading(),
      });

      await api.put(
        `/alertas/finalizar/${marcador.id_ocorrencia}`,
        {
          finalizado_por: localStorage.getItem("clientID"),
          obs: obs.trim(),
        }
      );

      await fetchData();

      await Swal.fire({
        icon: "success",
        title: "Alerta finalizado",
        text: "A notificação foi encerrada com sucesso.",
        background: "#0b1923",
        color: "#edf7fb",
        timer: 1600,
        showConfirmButton: false,
        customClass: {
          popup: "swal-finalizar-premium",
          title: "swal-finalizar-titulo",
        },
      });
    } catch (error) {
      console.error("Erro ao finalizar alerta:", error);

      if (e?.target) e.target.checked = false;

      Swal.fire({
        icon: "error",
        title: "Falha ao finalizar",
        text: "Não foi possível concluir a solicitação. Tente novamente.",
        background: "#0b1923",
        color: "#edf7fb",
        confirmButtonText: "Entendi",
        buttonsStyling: false,
        customClass: {
          popup: "swal-finalizar-premium",
          title: "swal-finalizar-titulo",
          confirmButton: "swal-finalizar-confirmar",
        },
      });
    }
  };


  //FINALIZAR TODOS OS ALERTAS SELECIONADOS


  const finalizarTodos = async () => {
    if (!selectedItems.length) return;

    const escapeHtml = (value) =>
      String(value ?? "").replace(/[&<>"']/g, (char) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[char]);

    const quantidade = selectedItems.length;

    const { value: obs, isConfirmed } = await Swal.fire({
      title: "Finalizar alertas",
      background: "#0b1923",
      color: "#edf7fb",
      width: 420,
      padding: "26px",

      html: `
      <div style="text-align:left;margin-top:6px">
        <p style="
          margin:0 0 24px;
          color:#8da8b7;
          font-size:13px;
          line-height:1.6;
        ">
          Você está prestes a encerrar os alertas selecionados.
        </p>

        <div style="
          display:flex;
          align-items:center;
          gap:16px;
          padding:17px 0;
          margin-bottom:20px;
          border-top:1px solid rgba(148,190,210,.13);
          border-bottom:1px solid rgba(148,190,210,.13);
        ">
          <div style="
            display:flex;
            align-items:center;
            justify-content:center;
            width:44px;
            height:44px;
            flex-shrink:0;
            border-radius:12px;
            background:rgba(56,189,248,.09);
            color:#7dd3fc;
            font-size:21px;
          ">
            ✓
          </div>

          <div>
            <div style="
              color:#f0f8fc;
              font-size:25px;
              line-height:1.2;
              font-weight:650;
              letter-spacing:-.7px;
            ">
              ${quantidade.toLocaleString("pt-BR")}
            </div>

            <div style="
              margin-top:5px;
              color:#8da8b7;
              font-size:12px;
            ">
              ${quantidade === 1 ? "alerta selecionado" : "alertas selecionados"}
            </div>
          </div>
        </div>

        <label for="obs-finalizar-todos" style="
          display:block;
          margin-bottom:8px;
          color:#a8c0cc;
          font-size:11px;
          font-weight:600;
          letter-spacing:.5px;
          text-align:left;
        ">
          OBSERVAÇÃO <span style="color:#63c8ee">*</span>
        </label>
      </div>
    `,

      input: "textarea",
      inputPlaceholder: "Descreva o motivo da finalização...",
      inputAttributes: {
        id: "obs-finalizar-todos",
        "aria-label": "Observação obrigatória",
        maxlength: 2000,
      },

      customClass: {
        popup: "swal-finalizar-premium",
        title: "swal-finalizar-titulo",
        htmlContainer: "swal-finalizar-conteudo",
        input: "swal-finalizar-input",
        confirmButton: "swal-finalizar-confirmar",
        cancelButton: "swal-finalizar-cancelar",
      },

      inputValidator: (value) => {
        if (!value?.trim()) {
          return "A observação é obrigatória.";
        }
      },

      showCancelButton: true,
      confirmButtonText: "Finalizar todos",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      focusCancel: true,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    if (!isConfirmed) return;

    try {
      Swal.fire({
        title: "Finalizando alertas",
        html: `
        <div style="
          margin-top:8px;
          color:#8da8b7;
          font-size:12px;
        ">
          Processando ${quantidade.toLocaleString("pt-BR")}
          ${quantidade === 1 ? "alerta" : "alertas"}...
        </div>
      `,
        background: "#0b1923",
        color: "#edf7fb",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: "swal-finalizar-premium",
        },
        didOpen: () => Swal.showLoading(),
      });

      const resultados = await Promise.allSettled(
        selectedItems.map((item) =>
          api.put(
            `/alertas/finalizar/${item.id_ocorrencia}`,
            {
              finalizado_por: localStorage.getItem("clientID"),
              obs: obs.trim(),
            }
          )
        )
      );

      const sucesso = resultados.filter(
        (resultado) => resultado.status === "fulfilled"
      ).length;

      const falhas = resultados.length - sucesso;

      setSelectedItems([]);
      await fetchData();

      if (falhas > 0) {
        await Swal.fire({
          icon: "warning",
          title: "Finalização parcial",
          html: `
          <div style="color:#a8bdc9;font-size:13px;line-height:1.8">
            <div><strong style="color:#7dd3fc">${sucesso}</strong> finalizados com sucesso</div>
            <div><strong style="color:#fbbf24">${falhas}</strong> não puderam ser finalizados</div>
          </div>
        `,
          background: "#0b1923",
          color: "#edf7fb",
          confirmButtonText: "Entendi",
          buttonsStyling: false,
          customClass: {
            popup: "swal-finalizar-premium",
            title: "swal-finalizar-titulo",
            confirmButton: "swal-finalizar-confirmar",
          },
        });

        return;
      }

      await Swal.fire({
        icon: "success",
        title: "Alertas finalizados",
        html: `
        <div style="color:#a8bdc9;font-size:13px;line-height:1.7">
          ${sucesso.toLocaleString("pt-BR")}
          ${sucesso === 1 ? "alerta foi finalizado" : "alertas foram finalizados"}
          com sucesso.
        </div>
      `,
        background: "#0b1923",
        color: "#edf7fb",
        timer: 1800,
        showConfirmButton: false,
        customClass: {
          popup: "swal-finalizar-premium",
          title: "swal-finalizar-titulo",
        },
      });
    } catch (error) {
      console.error("Erro ao finalizar alertas:", error);
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Erro ao finalizar",
        text: "Não foi possível concluir a operação.",
        background: "#0b1923",
        color: "#edf7fb",
        confirmButtonText: "Entendi",
        buttonsStyling: false,
        customClass: {
          popup: "swal-finalizar-premium",
          title: "swal-finalizar-titulo",
          confirmButton: "swal-finalizar-confirmar",
        },
      });
    }
  };



  return (
    <>
      <ToastContainer />



      <div className="alertas-page">
       

        <section className="alertas-ui-panel">
           <Preloader
          show={loading}
          text="Carregando Alertas Gerados..."
          customClass="laoder-alerta"
        />



          <header className="alertas-ui-header">

            <div className="alertas-ui-heading">

              <div className="alertas-ui-heading-icon">
                <MdNotificationsOff size={21} />
              </div>

              <div className="alertas-ui-heading-text">
                <h1 className="alertas-ui-title">Alertas</h1>
                <p className="alertas-ui-subtitle">
                  Consulte ocorrências, endereços e status dos alertas
                </p>
              </div>
            </div>

            <button
              type="button"
              className="alertas-ui-close"
              onClick={() => navigate(-1)}
              aria-label="Fechar alertas"
              title="Fechar"
            >
              ✕
            </button>
          </header>

          <div className="alertas-ui-toolbar">
            <div className="alertas-ui-toolbar-description">
              <span className="alertas-ui-toolbar-label">
                Central de alertas
              </span>
              <span className="alertas-ui-toolbar-hint">
                Acompanhe as ocorrências e finalize os alertas quando necessário.
              </span>
            </div>

            <div className="alertas-ui-toolbar-stats">
              <span className="alertas-ui-stat-label">Total de alertas</span>
              <strong className="alertas-ui-stat-value">{totalItems}</strong>
            </div>
          </div>

          <main className="alertas-ui-table-container">

            <div className="alertas-ui-table-scroll">
              <table className="alertas-ui-table">
                <img src={logo} className="logo"></img>
                <thead>
                  <tr>
                    <th className="alertas-ui-col-placa" scope="col">Placa</th>
                    <th className="alertas-ui-col-endereco" scope="col">Endereço</th>
                    <th className="alertas-ui-col-data" scope="col">Data</th>
                    <th className="alertas-ui-col-tipo" scope="col">Tipo</th>
                    <th className="alertas-ui-col-mensagem" scope="col">Mensagem</th>
                    <th className="alertas-ui-col-status" scope="col">Status</th>

                    <th className="alertas-ui-col-selecao" scope="col">
                      <label
                        className="alertas-ui-checkbox"
                        title="Selecionar todos os alertas"
                      >
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            totalItems > 0 &&
                            selectedItems.length === totalItems
                          }
                          ref={(input) => {
                            if (input) {
                              input.indeterminate =
                                selectedItems.length > 0 &&
                                selectedItems.length < totalItems;
                            }
                          }}
                          aria-label="Selecionar todos os alertas"
                        />
                        <span className="alertas-ui-checkmark" />
                      </label>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {marcadores.length > 0 ? (
                    marcadores.map((marcador) => (
                      <tr key={marcador.id_ocorrencia}>
                        <td className="alertas-ui-placa">
                          {marcador.placa || (
                            <span className="alertas-ui-empty-value">
                              Não informada
                            </span>
                          )}
                        </td>

                        <td>
                          <div className="alertas-ui-address">
                            {marcador.endereco || (
                              <span className="alertas-ui-empty-value">
                                Endereço não disponível
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="alertas-ui-date">
                          {new Date(marcador.data_posicao)
                            .toLocaleString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            })
                            .replace(",", " |")}
                        </td>

                        <td>
                          <span className="alertas-ui-type">
                            {formatarTipo(marcador.tipo)}
                          </span>
                        </td>

                        <td className="alertas-ui-message">
                          {formatarMensagem(
                            marcador.mensagem,
                            marcador.tipo
                          )}
                        </td>

                        <td className="alertas-ui-status">
                          {marcador.finalizado_por ? (
                            <span className="alertas-ui-status-finished">
                              <span className="alertas-ui-status-dot" />
                              {marcador.finalizado_por}
                            </span>
                          ) : (
                            <div className="alertas-ui-status-active">
                              <span className="alertas-ui-status-label">
                                Alerta ativo
                              </span>

                              <label
                                className="alertas-ui-checkbox"
                                title="Selecionar ou finalizar este alerta"
                              >
                                <input
                                  type="checkbox"
                                  onClick={(e) => finalizarAlerta(marcador, e)}
                                  checked={selectedItems.some(
                                    (item) =>
                                      item.id_ocorrencia ===
                                      marcador.id_ocorrencia
                                  )}
                                  readOnly
                                  aria-label={`Selecionar alerta ${marcador.placa || marcador.id_ocorrencia
                                    }`}
                                />
                                <span className="alertas-ui-checkmark" />
                              </label>
                            </div>
                          )}
                        </td>

                        <td className="alertas-ui-selection-cell">
                          {marcador.finalizado_por ? (
                            <span className="alertas-ui-finished-mark" title="Alerta finalizado">
                              ✓
                            </span>
                          ) : (
                            <span className="alertas-ui-selection-indicator" aria-hidden="true">
                              •
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <div className="alertas-ui-empty">
                          <MdNotificationsOff size={30} />
                          <strong>Nenhum alerta encontrado</strong>
                          <span>
                            Não existem ocorrências para exibir nesta página.
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </main>

          {selectedItems.length > 0 && (
            <div className="alertas-ui-bulk-actions">
              <span>
                <strong>{selectedItems.length}</strong>{" "}
                {selectedItems.length === 1
                  ? "alerta selecionado"
                  : "alertas selecionados"}
              </span>

              <Tooltip
                title="Finalizar alertas selecionados"
                arrow
                placement="top"
              >
                <button
                  type="button"
                  className="alertas-ui-finish-selected"
                  onClick={finalizarTodos}
                >
                  <MdNotificationsOff size={18} />
                  <span>Finalizar alertas</span>
                </button>
              </Tooltip>
            </div>
          )}

          <footer className="alertas-ui-footer">
            <div className="alertas-ui-summary">
              <span>
                Total de{" "}
                <strong>
                  {totalItems} {totalItems === 1 ? "alerta" : "alertas"}
                </strong>
              </span>

              <span className="alertas-ui-divider" />

              <span>
                Página <strong>{currentPage}</strong> de{" "}
                <strong>{totalPages}</strong>
              </span>
            </div>

            <nav className="alertas-ui-pagination" aria-label="Paginação de alertas">
              <button
                type="button"
                className="alertas-ui-page-button"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Página anterior"
              >
                «
              </button>

              {totalPages >= 1 && (
                <button
                  type="button"
                  className={`alertas-ui-page-button ${currentPage === 1 ? "active" : ""
                    }`}
                  onClick={() => handlePageChange(1)}
                  aria-current={currentPage === 1 ? "page" : undefined}
                >
                  1
                </button>
              )}

              {currentPage > 2 && (
                <button
                  type="button"
                  className="alertas-ui-page-button"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  {currentPage - 1}
                </button>
              )}

              {currentPage !== 1 && currentPage !== totalPages && (
                <button
                  type="button"
                  className="alertas-ui-page-button active"
                  aria-current="page"
                >
                  {currentPage}
                </button>
              )}

              {currentPage < totalPages - 1 && (
                <button
                  type="button"
                  className="alertas-ui-page-button"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  {currentPage + 1}
                </button>
              )}

              {totalPages > 1 && (
                <button
                  type="button"
                  className={`alertas-ui-page-button ${currentPage === totalPages ? "active" : ""
                    }`}
                  onClick={() => handlePageChange(totalPages)}
                  aria-current={currentPage === totalPages ? "page" : undefined}
                >
                  {totalPages}
                </button>
              )}

              <button
                type="button"
                className="alertas-ui-page-button"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                aria-label="Próxima página"
              >
                »
              </button>
            </nav>

            <label className="alertas-ui-page-size">
              <span>Exibir</span>
              <select
                onChange={limits}
                value={itemsPerPage}
                aria-label="Quantidade de alertas por página"
              >
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="600">600</option>
              </select>
              <span>por página</span>
            </label>
          </footer>
        </section>
      </div>
    </>
  );


}

export default Alertas;
